import React from 'react';
import PropTypes from 'prop-types';

class StorePicker extends React.Component {

  myInput = React.createRef();
  static propTypes = {
    history: PropTypes.object
  };

  goToStore = e => {
    e.preventDefault();
    const storeName = this.myInput.value.value;
    this.props.history.push(`/store/${storeName}`);
  }

  render() {
    return (
      <form className="store-selector" onSubmit={this.goToStore}>
        <h2>Catch of the Day</h2>
        <input
          type="text"
          ref={this.myInput}
          required placeholder="Store Name" defaultValue="fintastic"
        />
        <button type="submit">Visit Ofishal Store -></button>
      </form>
    );
  }
}

export default StorePicker;



// WEBPACK FOOTER //
// ./src/components/StorePicker.js